module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('notifications'), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "mainPanel"
    }
  }, [_c('TopNavbar'), _vm._v(" "), _c('Content'), _vm._v(" "), _c('ContentFooter')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e20bd464!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/Layout.vue
// module id = 565
// module chunks = 1